import { cacheKeys } from "@constants/cache-keys";
import { PointsBasedTagsDetailView } from "@features/dashboard/components/Progress/PointsBasedTagsDetailView";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import useAuthUser from "@hooks/useAuthUser";
import { titleCase } from "@memorang/helpers/common";
import type { MixedItemDist } from "@memorang/types";
import { useQueryClient } from "@tanstack/react-query";
import TopicsDetailView from "components/Topics/TopicsDetailView";
import { useLocalSearchParams } from "expo-router";

const DetailedListMasteryContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();

	const { userPublicMetadataId } = useAuthUser();

	const {
		currentExamContext: { studyPackCollectionId, examId },
	} = useExamContext();

	const queryClient = useQueryClient();
	const showPointsBasedScore = useAppStore(
		(state) => state.reportView?.formative?.showPointsBasedScore,
	);
	const mixedItemDistResponse = queryClient.getQueryData<MixedItemDist>([
		cacheKeys.home,
		userPublicMetadataId,
		"COMMON_DISTRIBUTION",
		examId,
		...(studyPackCollectionId ? [studyPackCollectionId] : []),
	]);

	if (!mixedItemDistResponse) {
		return null;
	}

	const { tags } = mixedItemDistResponse;

	if (showPointsBasedScore) {
		return (
			<PointsBasedTagsDetailView title={`${titleCase(type!)}s`} tags={tags} />
		);
	}

	return <TopicsDetailView tags={tags} type={type} />;
};

export default DetailedListMasteryContainer;
